import { Column } from "@/components/Datatable/types";
import { CertificateDownloadLink } from "@/components/TrainingCertificate/CertificateDownloadLink";
import { MyTrainingHistoryItem } from "../../api/fetchMyTrainingHistory/types";

export function myTrainingHistoryColumns(): Column<MyTrainingHistoryItem>[] {
  return [
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session Dates",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionDates,
    },
    {
      header: "Location",
      accessorKey: "locationName",
      enableSorting: true,
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Certificate",
      accessorKey: "certificate",
      cell: ({ row }) =>
        row.original.certificate ? (
          <CertificateDownloadLink
            attendeeName={row.original.fullName}
            courseName={row.original.eventName}
            sessionDates={row.original.sessionDates}
          />
        ) : (
          ""
        ),
    },
  ];
}
